import { goToNextPayload, goToPreviousPayload } from "~/events";
import { trackersFactory } from "~/events/trackersFactory";

export const previousFactory = (trackerPage: string) => {
  const trackers = trackersFactory(trackerPage);

  return () => trackers(goToPreviousPayload);
};

export const nextFactory = (trackerPage: string) => {
  const trackers = trackersFactory(trackerPage);

  return () => trackers(goToNextPayload);
};
